module.exports = __webpack_public_path__ + "static/media/LA.ee0ec0a8.png";